import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function WwwNode1(props) {
    return <NodeWithMultipleHandles {...props} nodeType="www1" />;
}
